export const APPLE_ID_SCRIPT = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";

export type AppleIdConfig = {
  clientId: string;
  scope: string;
  redirectURI: string;
  usePopup: boolean;
  state?: string;
  nonce?: string;
};

export type AppleIdSignInResponse = {
  authorization: { id_token: string; code: string; state?: string };
  user?: { email?: string; name?: { firstName?: string; lastName?: string } };
};

export type AppleIdAuth = {
  init(config: AppleIdConfig): void;
  signIn(): Promise<AppleIdSignInResponse>;
};

const loading = new Map<string, Promise<void>>();

export const loadScript = (src: string): Promise<void> => {
  const existing = loading.get(src);
  if (existing) {
    return existing;
  }
  const promise = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = src;
    script.addEventListener("load", () => resolve());
    script.addEventListener("error", () => {
      loading.delete(src);
      script.remove();
      reject(new Error(`Failed to load ${src}`));
    });
    document.head.appendChild(script);
  });
  loading.set(src, promise);
  return promise;
};

export const loadAppleIdAuth = async (): Promise<AppleIdAuth> => {
  await loadScript(APPLE_ID_SCRIPT);
  const auth = (window as unknown as { AppleID?: { auth?: AppleIdAuth } }).AppleID?.auth;
  if (!auth) {
    throw new Error("Sign in with Apple JS is not available");
  }
  return auth;
};
